import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
const KEY = "ss_compare";
const MAX = 3;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      const raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    sessionStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const isSelected = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback((id) => {
    setIds((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= MAX) {
        toast.error(`You can compare up to ${MAX} hospitals`);
        return prev;
      }
      return [...prev, id];
    });
  }, []);

  const add = useCallback((id) => {
    setIds((prev) => (prev.includes(id) || prev.length >= MAX ? prev : [...prev, id]));
  }, []);

  const remove = useCallback((id) => setIds((prev) => prev.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);
  const setMany = useCallback((list) => setIds(list.slice(0, MAX)), []);

  return (
    <CompareContext.Provider value={{ ids, isSelected, toggle, add, remove, clear, setMany, max: MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
